import { onMounted } from 'vue'
import useGet from '../../../core/composables/api/useGet'
import type { Member } from '../../../core/models/member/member'
import { useEventBus } from '@vueuse/core'
import { EventKey } from '../../../core/events/event-key'
import type { FeedbackFilterParams } from './useFeedbackFilter'

export const useFeedbackHistory = (query?: Partial<FeedbackFilterParams>) => {
  const { data, load, status } = useGet<FeedbackHistory>('feedback/history')

  onMounted(() => {
    load({ query: query })
  })

  const bus = useEventBus(EventKey.feedbackUpdated)
  bus.on(() => load({ query: query }))

  return {
    load,
    status,
    data,
  }
}

export type FeedbackHistory = ReadonlyArray<StructuredFeedbackItem | UnstructuredFeedbackItem>

export type StructuredFeedbackItem = {
  readonly type: 'structured'
  readonly id: string
  readonly receiver: Member
  readonly sender?: Member
  readonly anonymousSenderId?: string
  readonly updatedAt: string
  readonly feedbackAmount: number
  readonly survey: {
    readonly id: string
    readonly title: string | null
    readonly feedbackTopics: ReadonlyArray<{
      readonly id: string
      readonly title: string
      readonly icon?: string
    }>
  }
}

export type UnstructuredFeedbackItem = {
  readonly type: 'unstructured'
  readonly id: string
  readonly updatedAt: string
  readonly receiver: Member
  readonly sender: Member
  readonly text: JSON
}
